import { Breadcrumbs } from '../../../Home/Breadcrumb';
import { BuscarInstalacion } from '../Buscar';
import { TablaInstalacion } from '../Table';
import { ToastContainer } from 'react-toastify';

export const Instalaciones = () => {
  return (
    <>
      <ToastContainer />
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <Breadcrumbs title={'Consulta de Instalaciones'} />
            <BuscarInstalacion />
            <br />
            <TablaInstalacion />
          </div>
        </div>
      </div>
    </>
  );
};
